import { useEffect } from 'react'

/**
 * Hook to handle escape key press for closing modals/popups
 * @param onEscape - Callback function to execute when Escape is pressed
 * @param enabled - Whether the hook is active (default: true)
 */
export function useEscapeKey(onEscape: () => void, enabled: boolean = true): void {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault()
        onEscape()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onEscape, enabled])
}
